var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMagnifierCheck = function SvgMagnifierCheck(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 14.799",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 5813"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.847 9.825a4.932 4.932 0 1 1 6.975 0 4.94 4.94 0 0 1-6.975 0m11.852 3.267-3.244-3.05a6.337 6.337 0 1 0-1.412 1.412L13.31 14.5a.985.985 0 0 0 1.412 0 1 1 0 0 0-.023-1.412Z",
    "data-name": "Pfad 542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.8 5.274-3.391 3.39-1.9-1.9.6-.61 1.3 1.29 2.78-2.78Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMagnifierCheck);
export default ForwardRef;